import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import { Topbar } from '@/components/Topbar';
import { BigTextarea } from '@/components/BigTextarea';
import { Icon } from '@/components/Icon';
import { haptic } from '@/lib/telegram';

const HINTS = [
  'Что вы продвигаете (продукт/услуга)',
  'Целевая аудитория и боль, на которую давим',
  'Тон диалога (дружеский / технарский / лайфхак)',
  'Что упоминаем в финальной реплике (CTA / рефка / приглашение в бот)',
];

export function CampaignPromptsPage(): JSX.Element {
  const { id } = useParams();
  const cid = Number(id);
  const { data } = useAsync(() => api.getCampaign(cid), [cid]);
  const [brief, setBrief] = useState('');
  const [dm, setDm] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (data) {
      setBrief(data.dialogPrompt ?? '');
      setDm(data.dmReplyPrompt ?? '');
    }
  }, [data]);

  const save = async () => {
    haptic('success');
    await api.updateCampaign(cid, { dialogPrompt: brief, dmReplyPrompt: dm });
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <div className="space-y-4">
      <Topbar title="Промпты ИИ" subtitle="бриф диалогов · ответы в ЛС" />

      <section className="card p-4">
        <div className="mb-1 flex items-center gap-2">
          <Icon name="sparkles" className="text-accent-300" size={16} />
          <h2 className="text-sm font-semibold text-ink-50">Бриф для диалогов</h2>
        </div>
        <p className="mb-3 text-xs text-ink-500">
          Главный промпт. На его основе генерируются цепочки A↔B. Чем конкретнее — тем естественнее.
        </p>
        <BigTextarea
          rows={7}
          value={brief}
          onChange={setBrief}
          placeholder={'Например: «Естественный разговор о выборе майнинг-пула. B хвалит 44pool за низкие комиссии…»'}
        />
        <ul className="mt-3 space-y-1 text-2xs text-ink-500">
          {HINTS.map((h) => <li key={h}>· {h}</li>)}
        </ul>
      </section>

      <section className="card p-4">
        <div className="mb-1 flex items-center gap-2">
          <Icon name="message" className="text-accent-300" size={16} />
          <h2 className="text-sm font-semibold text-ink-50">Поведение в ЛС / на пинги</h2>
        </div>
        <p className="mb-3 text-xs text-ink-500">
          Этот промпт читает аккаунт, когда ему пишут в ЛС или пингуют в чате после посева.
        </p>
        <BigTextarea
          rows={6}
          value={dm}
          onChange={setDm}
          placeholder={'Например: «Отвечать как опытный майнер, рефку давать только по запросу»'}
        />
      </section>

      <button className="btn-primary w-full" onClick={save}>
        <Icon name="check" size={16} /> {saved ? 'Сохранено' : 'Сохранить промпты'}
      </button>
    </div>
  );
}
